export default function AnnouncementBanner({ message, link, linkText }) {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: "#4fa827",
        color: "#ffffff",
        padding: "10px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        fontSize: "14px",
        fontWeight: 500,
      }}
      data-testid="announcement-banner"
    >
      <span data-testid="announcement-banner-text">{message}</span>

      {link && (
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#d1fae5", textDecoration: "underline", fontWeight: 600 }}
          data-testid="announcement-banner-link"
        >
          {linkText || "En savoir plus"}
        </a>
      )}
    </div>
  );
}